import { Dispatch, SetStateAction } from 'react';
import { NewProject, Option } from 'utils/customTypes';
import { NEW_PROJECT_FORM_FIELDS } from 'utils/constants';
import { toUtcNoonIso } from 'utils/calendarDates';

const handleFieldChange = (
  fieldName: string,
  fieldValue: any,
  setData: Dispatch<SetStateAction<NewProject>>
) => {
  let updatedData = {};
  switch (fieldName) {
    case NEW_PROJECT_FORM_FIELDS.TASK_BUNDLE:
      updatedData = {
        [fieldName]: fieldValue,
      };
      break;
    case NEW_PROJECT_FORM_FIELDS.TARGET_LAUNCH_DATE:
      // targetLaunchDate is the one date field the save-path formatters
      // (formatProjectDateTypeFields / formatNewProjectDateTypeFields) do NOT
      // re-render to a local M/D/YYYY string, so the UTC-noon instant stamped
      // here goes to the API as-is (CP-10907). The other date fields must stay
      // raw picker Dates: those formatters read them with LOCAL getters, so
      // stamping them would show/save the next day for UTC+12..+14 users.
      updatedData = {
        [NEW_PROJECT_FORM_FIELDS.TARGET_LAUNCH_DATE]: toUtcNoonIso(
          fieldValue.startDate
        ),
      };
      break;
    case NEW_PROJECT_FORM_FIELDS.ACTUAL_COMPLETION_DATE:
      updatedData = {
        [NEW_PROJECT_FORM_FIELDS.ACTUAL_COMPLETION_DATE]: fieldValue.startDate,
      };
      break;
    case NEW_PROJECT_FORM_FIELDS.START_DATE:
      const { startDate, endDate } = fieldValue;
      updatedData = {
        [NEW_PROJECT_FORM_FIELDS.START_DATE]: startDate,
        [NEW_PROJECT_FORM_FIELDS.TARGET_COMPLETION_DATE]: endDate,
      };
      break;
    case NEW_PROJECT_FORM_FIELDS.TEAMS:
      updatedData = {
        learningTeams: fieldValue.map((option: Option) => option.value),
      };
      break;
    case NEW_PROJECT_FORM_FIELDS.BUSINESS_TEAMS:
      updatedData = {
        businessTeams: fieldValue.map((option: Option) => option.value),
      };
      break;
    case NEW_PROJECT_FORM_FIELDS.PROCESS:
      updatedData = {
        [fieldName]: fieldValue,
        [NEW_PROJECT_FORM_FIELDS.STAGE]: null,
      };
      break;
    case NEW_PROJECT_FORM_FIELDS.VENDORS:
      updatedData = {
        vendors: fieldValue.map((option: Option) => option.value),
      };
      break;
    case NEW_PROJECT_FORM_FIELDS.PROGRAMS:
      updatedData = {
        programs: fieldValue.map((option: Option) => option.value),
      };
      break;
    default:
      updatedData = {
        [fieldName]: fieldValue,
      };
  }
  setData((prevData) => ({ ...prevData, ...updatedData }));
};

export default handleFieldChange;
